import { ApiError, ApiNetworkError } from '@perplexicon/api-client';

/**
 * Resolves a user-comprehensible message from anything a mutation/query
 * can throw (APP_SPEC §37: "User-facing errors should be understandable").
 * Callers branch on `error.code` (never `error.message` text) when they
 * need to react to a *specific* failure (e.g. showing a field-level error
 * for `USERNAME_TAKEN`); this helper is for the generic fallback banner.
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    return error.message;
  }
  if (error instanceof ApiNetworkError) {
    return error.message;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Something went wrong. Please try again.';
}

/** True when `error` is the given API error code — the pattern every form/mutation error handler should use. */
export function isApiErrorCode(error: unknown, code: string): boolean {
  return error instanceof ApiError && error.code === code;
}
